/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import * as schemas from '@bingads-webui-campaign/campaign-ui-schemas';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
import timeZoneMapper from '@bingads-webui-component-legacy/timezonemapper/index';
import config from '@bingads-webui-component-legacy/config/index';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import * as campaignType from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/campaignType';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import PageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var viewModel = function (options) {
  this.shouldShowCashbackSettings = options.shouldShowCashbackSettings;
  this.shouldShowSponsoredCampaignCashbackOptIn = options.shouldShowSponsoredCampaignCashbackOptIn;
  this.isSponsoredCampaignCashbackOptedIn = ko.observable(options.isSponsoredCampaignCashbackOptedIn);
  this.isSponsoredCampaignCashbackOptInReadonly = options.isSponsoredCampaignCashbackOptInReadonly;
  this.isExperiment = options.isExperiment || (function () {
    return false;
  });
  this.isDisclaimerAdsEnabled = options.isDisclaimerAdsEnabled || (function () {
    return false;
  });
  this.isMixedDSACampaignRecommendation = options.isMixedDSACampaignRecommendation;
  this.isMixedDSACampaignCreate = ko.computed((function () {
    var currentCampaignType = campaignType.default();
    var isDSAMixedModeCampaignEnabled = _.result(config.get('Permissions'), 'IsDSAMixedModeCampaignEnabled', false);
    var isDisclaimerAllow = true;
    return (currentCampaignType === 'search' || options.campaignType === 'search') && isDSAMixedModeCampaignEnabled && !this.isExperiment() && (isDisclaimerAllow || !this.isDisclaimerAdsEnabled());
  }).bind(this));
  this.isAudienceCampaignCreate = ko.computed(function () {
    var currentCampaignType = campaignType.default();
    if (_.isString(currentCampaignType) && currentCampaignType !== 'audience') {
      return false;
    }
    return currentCampaignType === 'audience' || options.campaignType === 'audience';
  });
  this.campaignProps = ['Name', 'TimeZone'];
  ko_schema.properties(this, schemas.Campaign, this.campaignProps, _.defaults(options, {
    TimeZone: options.TimeZone || timeZoneMapper.getAccountTimeZone()
  }));
  if (options.scenario === 'signup-creation-workflow') {
    this.Name(i18n.getString('Campaigns_SearchCampaign') + ' 1');
  }
  this.Id = ko.observable(options.Id);
  this.languageError = ko.observable('');
  this.timeZoneText = i18n.get('TimeZone_' + this.TimeZone()).replace(/\{0\}\s*\{1\}\s*/, '');
  this.isAfterSave = ko.computed((function () {
    return !_.isUndefined(this.Id());
  }).bind(this));
  this.showTimeZoneText = ko.computed(function () {
    return options.scenario === 'campaign-settings';
  });
  this.hasChanges = ko.observable(false);
  this.enableMixedModeDSASettings = ko.observable(true);
  this.isMixedModeDSASettingsChecked = ko.observable(false);
  this.hasRsaAutoAssets = ko.observable(false);
  this.isRsaAutoAssetsSettingChecked = ko.observable(false);
  this.theme = config.get('theme');
  this.hasBroadOnlySetting = ko.observable(false);
  this.isBroadOnlySettingChecked = ko.observable(false);
  this.selectedBrandLists = ko.observableArray([]);
  this.deletedBrandListIds = ko.observableArray([]);
  this.addedBrandListIds = ko.observableArray([]);
  this.savedBrandListIds = ko.observableArray([]);
  this.showVanityUrlSettings = ko.observable(false);
  this.vanityUrlSettings = ko.observable({
    DisplayUrlMode: 'ManufacturerWebsiteUrl',
    WebsiteDescription: 'Unspecified'
  });
  this.campaignGoalText = _.result(_.find(options.CampaignSettings, i => _.has(i, 'CampaignObjectiveSettingType')), 'CampaignObjectiveSettingType');
  this.showCampaignGoal = ko.computed((function () {
    var isAmplifyEnabled = _.result(config.get('Permissions'), 'IsAmplifyEnabled', false);
    return !_.isEmpty(this.campaignGoalText) && isAmplifyEnabled;
  }).bind(this));
};
viewModel.prototype.getValues = function () {
  var context = {
    Name: this.Name(),
    TimeZone: this.TimeZone()
  };
  return context;
};
export default viewModel;

